const paramConfig = {
  PAGE_NUMBER: "page_no",
  DEFAULT_PAGE_NUMBER: 1,
  PAGE_SIZE: "page_size",
  DEFAULT_PAGE_SIZE: 200,
};

export default paramConfig;
